import React from 'react';

import { Box, SxProps, Theme, Typography } from '@mui/material';

import { ReactComponent as GreenRectangle } from '../../../assets/svg/greenRectangle.svg';
import { ReactComponent as StackedIcon } from '../../../assets/svg/stackedChips.svg';
import { getDayMonthDateYear } from '../../Reports/helpers';
import WithSkeleton from '../WithSkeleton';
import strings from '../../../localization';

import styles from './styles';

interface ILongTermContractLabels {
  isLongTerm?: boolean;
  contractStartDate?: string;
  contractEndDate?: string;
  successAction: string;
  customMultipleLabel?: string;
}

const getLongTermContractLabels = ({
  contractStartDate = '',
  contractEndDate = '',
  isLongTerm,
  successAction,
  customMultipleLabel,
}: ILongTermContractLabels) => {
  let ShiftConfig = {
    label: strings.singleShift,
    Icon: GreenRectangle,
    labelStyle: styles.singleShiftText as Record<string, string | number>,
    rangeLabel: '',
  };

  if (isLongTerm) {
    ShiftConfig = {
      label: customMultipleLabel ?? `${strings.multipleShifts}`,
      Icon: StackedIcon,
      labelStyle: styles.multipleShiftText,
      rangeLabel: `${getDayMonthDateYear(contractStartDate)} ${
        strings.to
      } ${getDayMonthDateYear(contractEndDate)}`,
    };
  }

  const SkeletonTypography = WithSkeleton({
    successAction,
    variant: 'rectangular',
    width: 150,
  })(Typography);

  const SkeletonBox = WithSkeleton({
    successAction,
    variant: 'rectangular',
    height: 20,
    width: 250,
  })(Box);

  return {
    ShiftLabel: ({ sx }: { sx?: SxProps<Theme> }) =>
      (
        <SkeletonBox sx={[styles.shiftLabelContainer, sx] as SxProps}>
          <ShiftConfig.Icon />
          <SkeletonTypography sx={[styles.shiftText, ShiftConfig.labelStyle]}>
            {ShiftConfig.label}
          </SkeletonTypography>
        </SkeletonBox>
      ),
    RangeLabel: ({ sx, onClick }: { sx?: SxProps<Theme>, onClick?: (e: React.MouseEvent<HTMLDivElement>) => void }) =>
      (isLongTerm ? (
        <SkeletonBox sx={[styles.rangeLabelContainer, sx] as SxProps}>
          <SkeletonTypography sx={styles.rangeLabel} onClick={onClick}>
            {ShiftConfig.rangeLabel}
          </SkeletonTypography>
        </SkeletonBox>
      ) : null),
  };
};

export default getLongTermContractLabels;
